module.exports = __webpack_public_path__ + "d0ccc0fc.svg";